import { Component, OnInit, ViewChild } from '@angular/core';
import { _tk } from '@wephone-translation';
import { FlexBasePage } from '@wephone-core-ui';
import { ActivatedRoute } from 'src/testing/activated-route-stub';
import { MatTabGroup } from '@angular/material/tabs';

@Component({
  selector: 'app-sms',
  templateUrl: './sms.component.html',
  styleUrls: ['./sms.component.scss']
})
export class SmsComponent extends FlexBasePage implements OnInit {
  @ViewChild(MatTabGroup) tabGroup: MatTabGroup;
  constructor(
    private readonly route: ActivatedRoute
  ) {
    super();
  }

  ngOnInit(): void {
    super.ngOnInit();
    if (this.tabGroup) {
      this.tabGroup.selectedIndex = 1;
    }

    this.route.queryParams.subscribe(
      params => {
        const tab = params['tab'];
        if (this.tabGroup && tab === 'handled_sms') {
          this.tabGroup.selectedIndex = 0;
        }
      }
    );
  }
}
